import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Row,
  Collapse,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation } from "react-router-dom";
// componentes
import ModalEditStatusPart from "./modalEditStatusPart";
import Pagination from "../../../components/Paginationv3";
import useDebounce from "../../../utils/hooks/useDebounce";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import ModalListHistoricPart from "./modalListHistoricPart";
import ModalEditMovePartVehicle from "./modalEditMovePartVehicle";
import ModalEditParticipant from "./modalEditParticipant";
import ModalViewParticipant from "./modalViewParticipants";
import ModalQRCode from "./modalQRCode";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import IconButton from "../../../components/Buttons/IconButton";
import DeleteButton from "../../../components/Buttons/DeleteButton";

// service
import {
  deleteAllTransfers,
  deleteTransfersByEventAndVehicle,
  deleteTransfer,
  getParticipantsByVehicle,
} from "../../../utils/services/transfer";
import {
  getParticipantById,
  getParticipants,
} from "../../../utils/services/participants";

export default function ModalListParticipants(props) {
  const { isOpen, toggle, data, getAllVehicles } = props;

  const columnsFilter = [
    { name: "Nome", value: "nome", type: "text" },
    { name: "Email", value: "email", type: "text" },
  ];
  const [modalEditStatus, setModalEditStatus] = useState(false);
  const [modalEditMoveVehicle, setModalEditMoveVehicle] = useState(false);
  const [modalEditParticipant, setModalEditParticipant] = useState(false);
  const [modalViewParticipant, setModalViewParticipant] = useState(false);
  const [modalQRCode, setModalQRCode] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [collapseOptions, setCollapseOptions] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  const [search, setSearch] = useState("");
  const [participants, setParticipants] = useState([]);
  const [participant, setParticipant] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modalHistoricPart, setModalHistoricPart] = useState(false);
  const [participantSelected, setParticipantSelected] = useState("");
  const [previousStatus, setPreviousStatus] = useState("");
  const [changeStatusBySelection, setChangeStatusBySelection] = useState(false);
  const [bulkDataStatus, setBulkDataStatus] = useState([]);
  const [deleteData, setDeleteData] = useState({});
  const [confirm_alert, setconfirm_alert] = useState(false);
  const [alertDeleteConfirmed, setAlertDeleteConfirmed] = useState(false);
  const [confirmAllDisabled, setConfirmAllDisabled] = useState(false);
  const [alertAllDeleteConfirmed, setAlertAllDeleteConfirmed] = useState(false);
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  const debouncedSearch = useDebounce(search, 300);

  const [activeFilter, setActiveFilter] = useState("nome");
  const location = useLocation();
  const idEvent = location.state.idEvent;
  function getAll() {
    getParticipantsByVehicle(
      data.eventId,
      data.id,
      currentIndex,
      itemsPerPage,
      treatmentSearch(),
      activeFilter,
    ).then((res) => {
      if (res.data.data) {
        setParticipants(res.data.data);
        setCountData(res.data.count);
      }
    });
  }
  function getOneParticipant(part) {
    getParticipantById(data.eventId, part, currentIndex, itemsPerPage).then(
      (res) => {
        if (res.data.data) {
          setModalViewParticipant(true);
          setParticipant(res.data.data);
        }
      },
    );
  }
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0]?.type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelected(participants.map((item) => item.participantId));
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (id, isChecked) => {
    if (isChecked) {
      setSelected((prev) => [...prev, id]);
    } else {
      setSelected((prev) => prev.filter((selectedId) => selectedId !== id));
    }
  };

  const isAllSelected =
    participants.length > 0 && selected.length === participants.length;
  const isIndeterminate =
    selected.length > 0 && selected.length < participants.length;

  function buildBulkData(opt) {
    const filteredParticipants = participants.filter((item) =>
      selected.includes(item.participantId.toString()),
    );

    setBulkDataStatus(filteredParticipants);
    if (opt === "status") {
      setModalEditStatus(true);
    }
    if (opt === "move") {
      setModalEditMoveVehicle(true);
    }
  }

  useEffect(() => {
    getParticipantsByVehicle(
      data.eventId,
      data.id,
      currentIndex,
      itemsPerPage,
      treatmentSearch(),
      activeFilter,
    ).then((res) => {
      if (res.data.data) {
        setParticipants(res.data.data);
        setCountData(res.data.count);
      }
    });
  }, [treatmentSearch(), currentIndex, itemsPerPage]);

  async function confirmDelete() {
    await deleteTransfer({
      jwt: "",
      id: deleteData.id,
    }).then(() => {
      setconfirm_alert(false);
      setAlertDeleteConfirmed(true);
    });
    // .catch((error) => console.log("error", error));
  }

  async function confirmDeleteAllTransfers() {
    deleteTransfersByEventAndVehicle({
      jwt: "",
      eventId: idEvent,
      vehicleId: data?.id,
    }).then((response) => {
      setConfirmAllDisabled(false);
      setAlertAllDeleteConfirmed(true);
    });
  }

  return (
    <>
      {confirm_alert ? (
        <SweetAlert
          title={`Deseja deletar do veículo o Participante: ${deleteData?.participantName}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setconfirm_alert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {alertDeleteConfirmed ? (
        <SweetAlert
          success
          title={"Deletado"}
          onConfirm={() => {
            setAlertDeleteConfirmed(false);
            getAll();
          }}
        >
          Participante deletado com sucesso!
        </SweetAlert>
      ) : null}

      {alertAllDeleteConfirmed ? (
        <SweetAlert
          success
          title={"Deletado"}
          onConfirm={() => {
            setAlertAllDeleteConfirmed(false);
            getAll();
          }}
        >
          Participantes deletados com sucesso!
        </SweetAlert>
      ) : null}
      {confirmAllDisabled ? (
        <SweetAlert
          title={`Deseja remover todos os Participantes do veículo?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDeleteAllTransfers();
          }}
          onCancel={() => setConfirmAllDisabled(false)}
        >
          <a>Você não poderá reverter essa ação.</a>
        </SweetAlert>
      ) : null}

      {modalEditStatus && (
        <ModalEditStatusPart
          isOpen={modalEditStatus}
          toggle={() => {
            setModalEditStatus(false);
          }}
          eventId={data.eventId}
          vehicleId={data.id}
          loginId={participantSelected}
          previousStatus={previousStatus}
          getAll={getAll}
          bulkData={bulkDataStatus}
          changeStatusBySelection={changeStatusBySelection}
        />
      )}
      {modalEditMoveVehicle && (
        <ModalEditMovePartVehicle
          isOpen={modalEditMoveVehicle}
          toggle={() => {
            setModalEditMoveVehicle(false);
            getAllVehicles();
          }}
          eventId={data.eventId}
          vehicleId={data.id}
          loginId={participantSelected}
          getAll={getAll}
          bulkData={bulkDataStatus}
          changeStatusBySelection={changeStatusBySelection}
        />
      )}
      {modalEditStatus && (
        <ModalEditStatusPart
          isOpen={modalEditStatus}
          toggle={() => {
            setModalEditStatus(false);
          }}
          eventId={data.eventId}
          vehicleId={data.id}
          loginId={participantSelected}
          previousStatus={previousStatus}
          getAll={getAll}
          bulkData={bulkDataStatus}
          changeStatusBySelection={changeStatusBySelection}
          handleSelectAll={handleSelectAll}
        />
      )}
      {modalHistoricPart && (
        <ModalListHistoricPart
          isOpen={modalHistoricPart}
          toggle={() => setModalHistoricPart(false)}
          data={data}
          loginId={participantSelected}
        />
      )}
      {modalEditParticipant && (
        <ModalEditParticipant
          isOpen={modalEditParticipant}
          toggle={() => {
            setModalEditParticipant(false);
          }}
          eventId={data.eventId}
          vehicleId={data.id}
          getAll={getAll}
          participantsInVehicle={participants}
        />
      )}
      {modalViewParticipant && (
        <ModalViewParticipant
          isOpen={modalViewParticipant}
          toggle={() => {
            setModalViewParticipant(false);
          }}
          participant={participant[0]}
          idEvent={data.eventId}
        />
      )}
      {modalQRCode && (
        <ModalQRCode
          isOpen={modalQRCode}
          toggle={() => {
            setModalQRCode(false);
          }}
          data={participants}
          eventId={data.eventId}
          vehicleId={data.id}
          getaAll={getAll}
        />
      )}
      <Modal isOpen={isOpen} centered autoFocus size="lg">
        <ModalHeader toggle={toggle}>Participantes por veículo</ModalHeader>
        <div style={{ padding: "0 20px", width: "100%" }}>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "50px",
            }}
          >
            <SectionComponent
              sectionName="Filtros"
              setIsOpen={setCollapseIsOpen}
              isOpen={collapseIsOpen}
            />
          </Row>
          <Collapse isOpen={collapseIsOpen}>
            <SearchFilters
              columns={columnsFilter}
              activeFilter={activeFilter}
              setActiveFilterHandle={setActiveFilterHandle}
            />
          </Collapse>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            // margin: "px 0",
          }}
        >
          <form
            className="app-search d-none d-lg-block events-input-search"
            onSubmit={(e) => e.preventDefault()}
            style={{ marginLeft: "15px", width: "40%" }}
          >
            <div className="position-relative">
              <input
                type={"text"}
                value={search}
                className="form-control"
                placeholder="Pesquisar..."
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="bx bx-search-alt" />
            </div>
          </form>

          <div
            className="mobile-btn-section"
            style={{ padding: "0 20px", width: "100%", marginBottom: 20 }}
          >
            <>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setCollapseOptions}
                isOpen={collapseOptions}
              />

              <Collapse isOpen={collapseOptions}>
                {/* <ActionButtonRounded
                  title="Ler QR Code"
                  onClick={() => {
                    setModalQRCode(true);
                  }}
                  type="mobile"
                /> */}

                <ActionButtonRounded
                  title="Adicionar Participante"
                  onClick={() => {
                    setModalEditParticipant(true);
                  }}
                  type="mobile"
                />

                {selected.length > 1 && (
                  <>
                    <ActionButtonRounded
                      title="Alterar Status em Massa"
                      onClick={() => {
                        setChangeStatusBySelection(true);
                        buildBulkData("status");
                      }}
                      type="mobile"
                    />

                    <ActionButtonRounded
                      title="Alterar PAX de Veículo em Massa"
                      onClick={() => {
                        setChangeStatusBySelection(true);
                        buildBulkData("move");
                      }}
                      type="mobile"
                    />
                  </>
                )}
              </Collapse>
            </>
          </div>

          <div className="header-btns-container">
            {selected.length > 1 && (
              <>
                <Button
                  style={{ marginRight: "10px", marginBottom: "10px" }}
                  color="primary"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => {
                    setChangeStatusBySelection(true);
                    buildBulkData("status");
                  }}
                >
                  Alterar Status em Massa
                </Button>
                <Button
                  style={{ marginRight: "15px", marginBottom: "10px" }}
                  color="primary"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => {
                    setChangeStatusBySelection(true);
                    buildBulkData("move");
                  }}
                >
                  Alterar PAX de Veículo em Massa
                </Button>
              </>
            )}
            {/* <ActionButtonRounded
              title="Ler QR Code"
              onClick={() => {
                setModalQRCode(true);
              }}
            /> */}

            <ActionButtonRounded
              title="Adicionar Participante"
              onClick={() => {
                setModalEditParticipant(true);
              }}
              margin={"0 20px 0 20px"}
            />
          </div>

          <div className="mobile-btn-section" style={{ width: "100%" }}>
            <Row className="mobile-btns-top">
              <form
                className="app-search"
                style={{ padding: "0px 20px" }}
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="position-relative">
                  <input
                    type={"text"}
                    value={search}
                    className="form-control"
                    placeholder="Pesquisar..."
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <span className="bx bx-search-alt" />
                </div>
              </form>
            </Row>
          </div>
        </div>
        <ModalBody>
          <div className="table-responsive" style={{ margin: "0px 0" }}>
            <p>
              <span style={{ fontSize: 14, fontWeight: "bold" }}>Veículo:</span>{" "}
              {data.description}
            </p>
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      checked={isAllSelected}
                      ref={(input) => {
                        if (input) input.indeterminate = isIndeterminate;
                      }}
                    />
                  </th>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {participants.map((item) => (
                  <tr key={item.participantId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(item.participantId)}
                        onChange={(e) =>
                          handleSelectOne(item.participantId, e.target.checked)
                        }
                      />
                    </td>
                    <td>{item.participantName}</td>
                    <td>{item.participantEmail}</td>
                    <td>
                      <span
                        className="tagDriver"
                        style={{
                          whiteSpace: "nowrap",
                          backgroundColor:
                            item?.status == "Embarcado"
                              ? "#50a5f1"
                              : item.status == "Desembarcado"
                                ? "#34c38f"
                                : item.status == "Não Embarcou"
                                  ? "#f46a6a"
                                  : "#f1b44c",
                        }}
                      >
                        {item?.status ? item?.status : "Pendente"}
                      </span>
                    </td>
                    <td>
                      <IconWithTooltip
                        color="blue"
                        className="mdi mdi-eye"
                        onClickAction={() => {
                          getOneParticipant(item.participantId);
                        }}
                        id={"id-view-data"}
                        tooltip="Informações do Participante"
                      />

                      <IconButton
                        className="mdi mdi-car-arrow-right"
                        color="green"
                        onClick={() => {
                          setChangeStatusBySelection(false);
                          setParticipantSelected(item.participantId);
                          setPreviousStatus(item.status);
                          setModalEditStatus(true);
                        }}
                        action="C"
                        margin={"0 5px 0 0"}
                        id={"id-change-status"}
                        tooltip="Alterar Status"
                      />

                      <IconWithTooltip
                        color="blue"
                        className="mdi mdi-note"
                        onClickAction={() => {
                          setModalHistoricPart(true);
                          setParticipantSelected(item.participantId);
                        }}
                        id={"id-historic-data"}
                        tooltip="Histórico do participante"
                      />

                      <IconButton
                        className="mdi mdi-swap-horizontal-circle"
                        color="darkblue"
                        onClick={() => {
                          setChangeStatusBySelection(false);
                          setParticipantSelected(item.participantId);
                          setModalEditMoveVehicle(true);
                        }}
                        action="C"
                        id={"id-change-vehicle"}
                        tooltip="Alterar Veículo"
                      />
                      <DeleteButton
                        onClick={() => {
                          setDeleteData(item);
                          setconfirm_alert(true);
                        }}
                        id={"id-delete-user"}
                        tooltip="Excluir"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div
            className="bottom-navigation"
            style={{
              marginTop: 10,
              justifyContent: `${
                participants?.length > 0 && showDeleteAll
                  ? "space-between"
                  : "end"
              }`,
            }}
          >
            {participants?.length > 0 && (
              <ActionButtonRounded
                onClick={() => setConfirmAllDisabled(true)}
                title="Limpar Todos Participantes"
                action="D"
                color="danger"
                setShow={setShowDeleteAll}
                verifyShow={true}
                width="200px"
              />
            )}
            <Pagination
              data={[]}
              search={search}
              currentIndex={currentIndex}
              setCurrentIndex={setCurrentIndex}
              countData={countData}
              maxItemPerPage={itemsPerPage}
              setMaxItemPerPage={setItemsPerPage}
              maxPageButtonsToShow={3}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

function IconWithTooltip(props) {
  const { color, onClickAction, className, id, tooltip } = props;
  return (
    <>
      <i
        className={className}
        id={id}
        style={{
          color: color,
          fontSize: 17,
          cursor: "pointer",
          marginRight: 5,
        }}
        onClick={onClickAction}
      />
      <UncontrolledTooltip
        style={{ backgroundColor: "#6f42c1" }}
        placement="bottom"
        target={id}
      >
        {tooltip}
      </UncontrolledTooltip>
    </>
  );
}
